import { useEffect } from 'react';
import { StanLoader, StanModal, StanProgressBar } from '@/components';
import { useExportCsv } from '../../hooks/useExportCsv';

interface ExportCsvModalProps {
    isOpen: boolean;
    onClose: () => void;
    filterArray: string | undefined;
    totalCustomers: number;
    totalPages: number;
}

export function ExportCsvModal({ isOpen, onClose, filterArray, totalCustomers, totalPages }: ExportCsvModalProps) {
    const { isExporting, currentPage, totalExportPages, progress, exportCsv, resetState } = useExportCsv({
        filterArray,
        totalPages,
        onSuccess: onClose,
    });

    // Reset state when modal opens
    useEffect(() => {
        if (isOpen) {
            resetState();
        }
    }, [isOpen, resetState]);

    const handleClose = () => {
        if (!isExporting) {
            onClose();
        }
    };

    return (
        <StanModal
            id='export-csv-modal'
            isOpen={isOpen}
            title='Exporting Audience'
            onClose={handleClose}
            primaryActionLabel={isExporting ? undefined : 'Export CSV'}
            secondaryActionLabel={isExporting ? undefined : 'Cancel'}
            primaryActionLoading={isExporting}
            onPrimaryAction={exportCsv}
            onSecondaryAction={handleClose}
            size='md'
        >
            <div className='flex flex-col gap-4'>
                {isExporting ? (
                    <div className='flex flex-col items-center gap-6 py-8'>
                        <StanLoader />
                        <StanProgressBar min={0} max={100} value={progress} className='w-full' />
                        <p className='text-gray text-label-xs-regular text-center'>
                            Fetching page {currentPage} of {totalExportPages}...
                        </p>
                    </div>
                ) : (
                    <div className='flex flex-col gap-4 text-center'>
                        <p className='text-gray text-label-sm-regular'>
                            Export {totalCustomers} customer{totalCustomers !== 1 ? 's' : ''} to CSV file.
                        </p>
                        <p className='text-gray text-label-xs-regular'>
                            This will download a CSV file containing all customer data matching your current filters.
                        </p>
                    </div>
                )}
            </div>
        </StanModal>
    );
}

ExportCsvModal.displayName = 'ExportCsvModal';
